import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My room in \"funny\" pictures",
  "description": "",
  "published": "2009-09-13T00:00:00.000Z",
  "redirect_from": ["/blog/my-room-in-funny-pictures/swizec/723"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Took these photos primarily for a certain forum I frequent and a thread therein, they are all lovingly annotated so I won't go into too much blabbering here. Just have a look.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      